module.exports = __webpack_public_path__ + "static/logo-light-4857f4cb85d802d0123f142a21a10eda.png";